
class ReferenceNetsBySignalDetail {
  constructor() {
    this.refInfo = new Map();
  }

  saveRefInfo = (channelId, data) => {
    return this.refInfo.set(channelId, data);
  }

  getRefInfo = (channelId) => {
    return this.refInfo.get(channelId);
  }

  cleanRefInfo = () => {
    this.refInfo = new Map();
  }
}

const referenceNetsBySignalDetail = new ReferenceNetsBySignalDetail();

export default referenceNetsBySignalDetail;